<template>
  <v-dialog v-model="dialog" persistent scrollable max-width="620px">
    <v-card class="profile-dialog-card entity-form-dialog classroom-create-dialog">
      <div class="profile-dialog-header entity-form-dialog__header">
        <div class="entity-form-dialog__title">
          <v-avatar size="44" color="green lighten-5">
            <v-icon color="primary">mdi-google-classroom</v-icon>
          </v-avatar>
          <div>
            <span>Classrooms</span>
            <h2>New classroom</h2>
            <p>Create a room within one of your departments.</p>
          </div>
        </div>
        <v-btn icon aria-label="Close new classroom dialog" @click.stop="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>

      <v-divider />

      <v-card-text class="profile-dialog-body entity-form-dialog__body">
        <section class="entity-form-dialog__section">
          <div class="entity-form-dialog__section-heading">
            <span><v-icon size="19" color="primary">mdi-door-open</v-icon></span>
            <div>
              <h3>Classroom details</h3>
              <p>Choose the department first, then name the classroom.</p>
            </div>
          </div>

          <v-row>
            <v-col cols="12">
              <v-autocomplete
                v-model="selectedClass"
                :items="Classes"
                :loading="classesLoading"
                clearable
                return-object
                item-text="name"
                outlined
                dense
                autofocus
                :error-messages="classErrors"
                :hide-details="classErrors.length === 0"
                label="Department"
                prepend-inner-icon="mdi-school-outline"
                no-data-text="No departments available"
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="ClassRoom.name"
                outlined
                dense
                :error-messages="nameErrors"
                :hide-details="nameErrors.length === 0"
                label="Classroom name"
                placeholder="For example: Room 101 or Beginner A"
              />
            </v-col>
            <v-col cols="12">
              <v-textarea
                v-model="ClassRoom.description"
                outlined
                dense
                hide-details
                auto-grow
                rows="2"
                :label="$t('labels.description')"
                placeholder="Optional notes about this classroom"
              />
            </v-col>
          </v-row>
        </section>
      </v-card-text>

      <v-divider />

      <v-card-actions class="profile-dialog-actions entity-form-dialog__actions">
        <v-btn text @click="close()">Cancel</v-btn>
        <v-btn color="primary" depressed :loading="loading" @click="submit()">
          <v-icon left small>mdi-plus</v-icon>
          Create classroom
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import classRoomService from "../service.js";
import classesService from "@/modules/Classes/service.js";

const { validationMixin } = require("vuelidate");
const { required } = require("vuelidate/lib/validators");

export default {
  name: "create-Class",
  props: {
    createDialog: {
      default: false,
    },
    createFromStore: {
      type: Boolean,
    },
  },
  data() {
    return {
      selectedClass: null,
      Classes: [],
      classesLoading: false,
      loading: false,
      dialog: false,
      ClassRoom: {
        name: null,
        classId: null,
        description: null,
      },
    };
  },
  mixins: [validationMixin],
  validations: {
    selectedClass: {
      required,
    },
    ClassRoom: {
      name: {
        required,
      },
    },
  },
  watch: {
    createDialog(val) {
      this.dialog = val;
    },
    dialog(val) {
      if (val) {
        this.getClasses();
      }
    },
  },
  computed: {
    ...mapGetters("global", ["currentUser"]),
    nameErrors() {
      const errors = [];
      if (!this.$v.ClassRoom.name.$dirty) return errors;
      if (!this.$v.ClassRoom.name.required)
        errors.push(this.$t("validations.fieldIsRequired"));

      return errors;
    },
    classErrors() {
      const errors = [];
      if (!this.$v.selectedClass.$dirty) return errors;
      if (!this.$v.selectedClass.required)
        errors.push("Department is required");
      return errors;
    },
  },
  methods: {
    getClasses() {
      this.classesLoading = true;
      return classesService
        .getAll()
        .then((response) => {
          this.Classes = response.data;
          return response;
        })
        .finally(() => {
          this.classesLoading = false;
        });
    },
    close() {
      this.empty();
      this.$emit("close");
    },
    empty() {
      this.ClassRoom = {
        name: null,
        classId: null,
        description: null,
      };
      this.selectedClass = null;
      this.$v.$reset();
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: this.$t("toastMessage.text.invalidFields"),
          });
      } else {
        this.loading = true;
        this.ClassRoom.ClassId = this.selectedClass.id
        return classRoomService
          .create(this.ClassRoom)
          .then((result) => {
            if (result.status) {
              this.$swal
                .mixin({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 3000,
                })
                .fire({
                  icon: "success",
                  title: "Classroom created",
                });
              this.loading = false;
              this.$emit("submit");
              this.close();
            }
          })
          .catch((err) => {
            this.loading = false;
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              })
              .fire({
                icon: "error",
                title: err && err.data ? err.data.message : "Classroom could not be created",
              });
          });
      }
    },
  },
};
</script>

<style scoped>
</style>
